

import { defineComponent, onMounted, ref, Component, computed } from 'vue';
import { IapComponent } from '../../component/domain/iapComponent';
import DynamicEditor from './controls/editorTemplates/prime/DynamicEditor.vue';
import DynamicCrudTabla from './controls/editorTemplates/prime/DynamicCrudTabla.vue';
import DynamicButton from './controls/editorTemplates/prime/DynamicButton.vue';
import DynamicToogleButton from './controls/editorTemplates/prime/DynamicToogleButton.vue';
import DynamicSplitButton from './controls/editorTemplates/prime/DynamicSplitButton.vue';
import DynamicPanel from './controls/editorTemplates/prime/DynamicPanel.vue';
import DynamicCheckBox from './controls/editorTemplates/prime/DynamicCheckBox.vue';
import DynamicDropDown from './controls/editorTemplates/prime/DynamicDropDown.vue';
import DynamicDropDownCascade from './controls/editorTemplates/prime/DynamicDropDownCascade.vue';
import DynamicInputSwitch from './controls/editorTemplates/prime/DynamicInputSwitch.vue';
import DynamicInputText from './controls/editorTemplates/prime/DynamicInputText.vue';
import DynamicInputNumber from './controls/editorTemplates/prime/DynamicInputNumber.vue';
import DynamicLabel from './controls/editorTemplates/prime/DynamicLabel.vue';
import DynamicRadioButton from './controls/editorTemplates/prime/DynamicRadioButton.vue';
import DynamicMultiSelect from './controls/editorTemplates/prime/DynamicMultiSelect.vue';
import DynamicChip from './controls/editorTemplates/prime/DynamicChip.vue';
import DynamicDivider from './controls/editorTemplates/prime/DynamicDivider.vue';
import DynamicImage from './controls/editorTemplates/prime/DynamicImage.vue';
import DynamicHtmlA from './controls/editorTemplates/prime/DynamicHtmlA.vue';
import DynamicTabPanel from './controls/editorTemplates/prime/DynamicTabPanel.vue';
import DynamicTabView from './controls/editorTemplates/prime/DynamicTabView.vue';
import DynamicTextArea from './controls/editorTemplates/prime/DynamicTextArea.vue';
import DynamicRating from './controls/editorTemplates/prime/DynamicRating.vue';
import DynamicPassword from './controls/editorTemplates/prime/DynamicPassword.vue';
import DynamicBadge from './controls/editorTemplates/prime/DynamicBadge.vue';
import DynamicKnob from './controls/editorTemplates/prime/DynamicKnob.vue';
import DynamicColorPicker from './controls/editorTemplates/prime/DynamicColorPicker.vue';
import { Container } from 'inversify';
import DynamicHtmlSpan from './controls/editorTemplates/prime/DynamicHtmlSpan.vue';
import ControlTypeConst from '../domain/Constants/ControlTypeConst';
import DynamicHtmlB from './controls/editorTemplates/prime/DynamicHtmlB.vue';
import DynamicHtmlBr from './controls/editorTemplates/prime/DynamicHtmlBr.vue';
import DynamicHtmlEm from './controls/editorTemplates/prime/DynamicHtmlEm.vue';
import DynamicHtmlH1 from './controls/editorTemplates/prime/DynamicHtmlH1.vue';
import DynamicHtmlH2 from './controls/editorTemplates/prime/DynamicHtmlH2.vue';
import DynamicHtmlH3 from './controls/editorTemplates/prime/DynamicHtmlH3.vue';
import DynamicHtmlH4 from './controls/editorTemplates/prime/DynamicHtmlH4.vue';
import DynamicHtmlH5 from './controls/editorTemplates/prime/DynamicHtmlH5.vue';
import DynamicHtmlH6 from './controls/editorTemplates/prime/DynamicHtmlH6.vue';
import DynamicHtmlHr from './controls/editorTemplates/prime/DynamicHtmlHr.vue';
import DynamicHtmlI from './controls/editorTemplates/prime/DynamicHtmlI.vue';
import DynamicHtmlP from './controls/editorTemplates/prime/DynamicHtmlP.vue';
import DynamicHtmlSmall from './controls/editorTemplates/prime/DynamicHtmlSmall.vue';
import DynamicHtmlStrong from './controls/editorTemplates/prime/DynamicHtmlStrong.vue';
import DynamicHtmlDiv from './controls/editorTemplates/prime/DynamicHtmlDiv.vue';
import DynamicCard from './controls/editorTemplates/prime/DynamicCard.vue';
import DynamicTimeLine from './controls/editorTemplates/prime/DynamicTimeLine.vue';
import DynamicAvatar from './controls/editorTemplates/prime/DynamicAvatar.vue';
import DynamicToolBar from './controls/editorTemplates/prime/DynamicToolBar.vue';
import DynamicTag from './controls/editorTemplates/prime/DynamicTag.vue';
import DynamicHtmlInput from './controls/editorTemplates/prime/DynamicHtmlInput.vue';
import DynamicColumn from './controls/editorTemplates/prime/DynamicColumn.vue';
import DynamicCalendar from './controls/editorTemplates/prime/DynamicCalendar.vue';
import DynamicScrollPanel from './controls/editorTemplates/prime/DynamicScrollPanel.vue';
import DynamicDataTable from './controls/editorTemplates/prime/DynamicDataTable.vue';
import DynamicHtmlIframe from './controls/editorTemplates/prime/DynamicHtmlIframe.vue';
import WidgetComponentDataTree from '../../designer/domain/widgetComponent';
import { useStore } from 'vuex';
import CatalogCompConst from '../../catalog/domain/const/CatalogCompConst';
import PanelTypeConst from '../domain/Constants/PanelTypeConst';
import DynamicDataView from './controls/editorTemplates/prime/DynamicDataView.vue';
import DataViewTypeConst from '../domain/Constants/DataViewTypeConst';
import ComponentCommon from '../domain/Functions/ComponentCommon';
import { IapComponentDataSource } from '@ilinium/shared/src/entidades/builder/component/domain/iapComponentDataSource';
import TimeLineTypeConst from '../domain/Constants/TimeLineTypeConst';
import { IapComponentAttribute } from '../../component/domain/iapComponentAttribute';
import CardTypeConst from '../domain/Constants/CardTypeConst';
import { IapCatalogType } from '../../catalog/domain/iapCatalogType';
import CrudTableTypeConst from '../domain/Constants/CrudTableTypeConst';
import DynamicMenu from './controls/editorTemplates/prime/DynamicMenu.vue';
import DynamicMenuItem from './controls/editorTemplates/prime/DynamicMenuItem.vue';
import MenuTypeConst from '../domain/Constants/MenuTypeConst';
import TabPanelTypeConst from '../domain/Constants/TabPanelTypeConst';
import FieldsetTypeConst from '../domain/Constants/FieldsetTypeConst';
import TabViewTypeConst from '../domain/Constants/TabViewTypeConst';
import DynamicFieldset from './controls/editorTemplates/prime/DynamicFieldset.vue';
import DynamicDialog from './controls/editorTemplates/prime/DynamicDialog.vue';
import DynamicLookUp from './controls/editorTemplates/prime/DynamicLookUp.vue';
import DynamicAutocomplete from './controls/editorTemplates/prime/DynamicAutocomplete.vue';
import DynamicChartBar from './controls/editorTemplates/prime/DynamicChartBar.vue';
import DynamicChartCirc from './controls/editorTemplates/prime/DynamicChartCirc.vue';
import { Dictionary } from '../../expression/domain/dictionary';
import BaseControlTypeConst from '../domain/Constants/BaseControlTypeConst';
import LookUpEditorTypeConst from '../domain/Constants/LookUpEditorTypeConst';
import AutocompleteTypeConst from '../domain/Constants/AutocompleteTypeConst';
import DialogTypeConst from '../domain/Constants/DialogTypeConst';
import HelperCommon from '../../../../common/infrastructure/funciones/HelperCommon';
import { LocalService } from '../../../../common/infrastructure/servicios';
import ComponentUtil from '../../designer/infrastructure/component/util/componentUtil';
import CatalogModelValueConst from '../../catalog/domain/const/CatalogModelValueConst';


export default defineComponent({
  name: 'dynamic_component_builder',
  components: {
    DynamicCalendar,
    DynamicCrudTabla,
    DynamicButton,
    DynamicPanel,
    DynamicCheckBox,
    DynamicDropDown,
    DynamicDropDownCascade,
    DynamicInputSwitch,
    DynamicInputText,
    DynamicInputNumber,
    DynamicLabel,
    DynamicRadioButton,
    DynamicMultiSelect,
    DynamicChip,
    DynamicDivider,
    DynamicImage,
    DynamicHtmlA,
    DynamicTabPanel,
    DynamicTabView,
    DynamicTextArea,
    DynamicHtmlSpan,
    DynamicHtmlB,
    DynamicHtmlBr,
    DynamicHtmlEm,
    DynamicHtmlH1,
    DynamicHtmlH2,
    DynamicHtmlH3,
    DynamicHtmlH4,
    DynamicHtmlH5,
    DynamicHtmlH6,
    DynamicHtmlHr,
    DynamicHtmlI,
    DynamicHtmlP,
    DynamicHtmlSmall,
    DynamicHtmlStrong,
    DynamicHtmlDiv,
    DynamicCard,
    DynamicTimeLine,
    DynamicAvatar,
    DynamicToolBar,
    DynamicTag,
    DynamicScrollPanel,
    DynamicDataTable,
    DynamicColumn,
    DynamicHtmlInput,
    DynamicHtmlIframe,
    DynamicDataView,
    DynamicMenu,
    DynamicMenuItem,
    DynamicRating,
    DynamicFieldset,
    DynamicLookUp,
    DynamicPassword,
    DynamicBadge,
    DynamicKnob,
    DynamicColorPicker,
    DynamicToogleButton,
    DynamicEditor,
    DynamicSplitButton,
    DynamicDialog,
    DynamicAutocomplete,
    DynamicChartBar,
    DynamicChartCirc
  },
  props:
  {
    container: {
      type: Object as () => Container
    },
    data: {
      type: Object as () => WidgetComponentDataTree,
      default: () => ({})
    },
    rootParentId:
    {
      type: Number,
      default: (-1)
    },

    dataSources: {
      type: Object as () => IapComponentDataSource[],
      default: () => ({})
    },
    slotProps: {
      type: Object,
      default: () => ({})
    },
    rootParentAttr: {
      type: Object as () => IapComponentAttribute[],
      default: () => ({})
    },
    addToRefControl: {
      type: Boolean,
      default: false
    },
  },
  setup(props, context) {
    const store = useStore();
    const ctrlDynamic = ref();
    const dataTree = computed({
      get: () => props.data,
      set: (val) => context.emit('update:data', val),
    });


    const componentDataSources = computed({
      get: () => props.dataSources,
      set: (val) => context.emit('update:dataSources', val),
    });


    const { getLayoutComponent, getContentComponent, isLayoutComponent, getAllLayoutComponent,getPropertyValue,getPropertyNumberValue } = ComponentCommon(props, context,store);



    const getChilds = computed(() => {

      if (dataTree.value.loaded) {

        return dataTree.value?.children;
      }
      else {
        return []
      }

    })

   


    onMounted(() => {    
      //controls.value.push({Component.id,controls })
      //resolveDatasource();
      //Components
    })

    return {
      dataTree,
      ControlTypeConst,
      CatalogCompConst,
      PanelTypeConst,
      getLayoutComponent,
      getContentComponent,
      isLayoutComponent,
      getAllLayoutComponent,
      DataViewTypeConst,
      getChilds,
      componentDataSources,
      TimeLineTypeConst,
      CardTypeConst,
      CrudTableTypeConst,
      MenuTypeConst,
      TabPanelTypeConst,
      getPropertyValue,
      getPropertyNumberValue,
      FieldsetTypeConst,
      ctrlDynamic,
      LookUpEditorTypeConst,
      DialogTypeConst,
      AutocompleteTypeConst,
      TabViewTypeConst

    };
  },
});
